import React from 'react'
import SideBar from 'components/sidebar'
import { Box, Card, HStack } from '@chakra-ui/react'
import mainImage from 'assets/images/mainbgImg.png'
type props = {
  children: JSX.Element
}
export default function MainLayout({ children }: props) {
  return (
    <HStack
      align={'start'}
      dir="ltr"
      p="2.5rem 0"
      gap="22px"
      className="bgImage scrollbar"
      bgImage={mainImage}
      bgRepeat="no-repeat"
      bgSize="cover"
      h="100%"
      bgPosition="center"
    >
      <Card flex={0.8} p="20px" bg="transparent" className="gradient-mask">
        {children}
      </Card>

      <Box flex={0.2}>
        <SideBar />
      </Box>
    </HStack>
  )
}
